import { render, staticRenderFns } from "./emptyImg.vue?vue&type=template&id=0609b4cc&scoped=true&"
import script from "./emptyImg.vue?vue&type=script&lang=js&"
export * from "./emptyImg.vue?vue&type=script&lang=js&"
import style0 from "./emptyImg.vue?vue&type=style&index=0&id=0609b4cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0609b4cc",
  null
  
)

export default component.exports